import { useMutation, useQueryClient, } from "@tanstack/react-query";
import { useState } from "react";
import { genIdempotencyKey } from "../../utils/genIdempotencyKey";
import { url } from "../request/findPortfolioPlanAssignment";
import { postPortfolioPlanAssignment, } from "../request/postPortfolioPlanAssignment";
import { assignmentsKeyMaker } from "./usePortfolioPlanAssignments";
const IDEMPOTENCY_DESCRIPTOR = "PortfolioPlan:Assignment:";
const usePostPortfolioAssignment = (portfolioPlanId, config) => {
    const [idempotencyKey, setIdempotencyKey] = useState(genIdempotencyKey(IDEMPOTENCY_DESCRIPTOR));
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: async (data) => {
            if (config === null) {
                throw new Error("No auth config");
            }
            return postPortfolioPlanAssignment(portfolioPlanId, data, idempotencyKey, config);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: assignmentsKeyMaker({ abstractPortfolioId: portfolioPlanId }),
            });
            queryClient.invalidateQueries({
                queryKey: [url(null, null)],
            });
            setIdempotencyKey(genIdempotencyKey(IDEMPOTENCY_DESCRIPTOR));
        },
    });
    return mutation;
};
export default usePostPortfolioAssignment;
//# sourceMappingURL=usePostPortfolioAssignment.js.map